import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  TextField,
  Container,
  Typography,
  MenuItem,
  Button,
  Box,
  Paper,
} from "@mui/material";

const lineasDeServicio = [
  { value: "300000058635046", label: "Corporativo" },
  { value: "300000058635173", label: "Licitaciones" },
  { value: "300000058635222", label: "Seguimiento" },
  { value: "300000058634831", label: "Linea Abierta" },
];

const canales = [
  { value: "INSTAGRAM", label: "Instagram" },
  { value: "LINKEDIN", label: "LinkedIn" },
  { value: "FACEBOOK", label: "Facebook" },
  { value: "EMAIL", label: "Email" },
  { value: "WEB", label: "Página Web" },
];

const Duplicar = (props) => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    titulo: "",
    lineaServicio: "",
    canal: "",
    descripcion: "",
  });

  useEffect(() => {
    fetch(
      `https://portaltransaccionalback.azurewebsites.net/api/GetPrincipalesId/${id}`
    )
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          titulo: data[0].titulo,
          lineaServicio: data[0].lineaServicio,
          canal: data[0].canal,
          descripcion: data[0].descripcion,
        });
      })
      .catch((error) => console.error("Error al obtener los datos:", error));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    const payload = {
      descripcion: formData.titulo,
      titulo: formData.titulo,
      estado: "0",
      publicacion: "",
      lineaServicio: formData.lineaServicio,
      canal: formData.canal,
    };

    fetch(
      "https://portaltransaccionalback.azurewebsites.net/api/PostPrincipal",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Respuesta del servidor:", data);
        alert("Datos guardados correctamente");
        navigate(`/DuplicaVariables/${id}/${data}`);
      })
      .catch((error) => console.error("Error al guardar los datos:", error));
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
      <Paper sx={{ p: 4, width: "100%", maxWidth: 600 }} elevation={3}>
        <Container maxWidth="sm" style={{ marginTop: 20 }}>
          <Typography variant="h6">Formulario de Edición</Typography>

          <TextField
            fullWidth
            label="Título"
            name="titulo"
            value={formData.titulo}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Descripción"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={4} // Ajusta el número de filas visibles
          />

          <TextField
            select
            fullWidth
            label="Línea de Servicio"
            name="lineaServicio"
            value={formData.lineaServicio}
            onChange={handleChange}
            margin="normal"
          >
            {lineasDeServicio.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="Canal"
            name="canal"
            value={formData.canal}
            onChange={handleChange}
            margin="normal"
          >
            {canales.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{ marginTop: 20 }}
          >
            Guardar
          </Button>
        </Container>
      </Paper>
    </Box>
  );
};

export default Duplicar;
